/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Models" />

export interface AboutProjectData {
    isAnyServiceInitialized: boolean;
    tagsData: TagsData;
    sourceRepositoryType: SourceRepositoryTypes | undefined;
    repositoryId: string | undefined;
}

export interface AboutRegionInfo {
    repositoryType: SourceRepositoryTypes | undefined;
    repositoryId: string | undefined;
}

export enum SourceRepositoryTypes {
    Git,
    Tfvc,
    Wiki
}

export interface TagsData {
    tags: string[];
}

export interface Permissions {
    hasViewActivityPanePermission: boolean;
}

export interface TagInfo {
    text: string;
    isFocusable: boolean;
    tooltipText?: string;
    tagItemAriaLabel?: string;
    deleteButtonAriaLabel?: string;
}

export interface AllProjectTagsInCollectionData {
    tags: string[];
    tagsFetched: boolean;
}
